export default __webpack_public_path__ + "static/media/transfer-network-confirmation-fail.bee152d4.svg";